/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListReferentialTagConversation } from '../models/api-response-list-referential-tag-conversation';
import { ApiResponseListReferentialVariable } from '../models/api-response-list-referential-variable';
import { ApiResponsePagedResultReferentialQuickMessage } from '../models/api-response-paged-result-referential-quick-message';
import { ApiResponseReferentialVariable } from '../models/api-response-referential-variable';
import { getReferentialVariableByName } from '../fn/referential-api/get-referential-variable-by-name';
import { GetReferentialVariableByName$Params } from '../fn/referential-api/get-referential-variable-by-name';
import { listReferentialConversationsTags } from '../fn/referential-api/list-referential-conversations-tags';
import { ListReferentialConversationsTags$Params } from '../fn/referential-api/list-referential-conversations-tags';
import { listReferentialVariable } from '../fn/referential-api/list-referential-variable';
import { ListReferentialVariable$Params } from '../fn/referential-api/list-referential-variable';
import { searchQuickMessage } from '../fn/referential-api/search-quick-message';
import { SearchQuickMessage$Params } from '../fn/referential-api/search-quick-message';

@Injectable({ providedIn: 'root' })
export class ReferentialApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchQuickMessage()` */
  static readonly SearchQuickMessagePath = '/v1/api/ui/referential/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchQuickMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchQuickMessage$Response(params: SearchQuickMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>> {
    return searchQuickMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchQuickMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchQuickMessage(params: SearchQuickMessage$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialQuickMessage> {
    return this.searchQuickMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialQuickMessage>): ApiResponsePagedResultReferentialQuickMessage => r.body)
    );
  }

  /** Path part for operation `getReferentialVariableByName()` */
  static readonly GetReferentialVariableByNamePath = '/v1/api/ui/referential/by-name';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferentialVariableByName()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getReferentialVariableByName$Response(params: GetReferentialVariableByName$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return getReferentialVariableByName(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReferentialVariableByName$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getReferentialVariableByName(params: GetReferentialVariableByName$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.getReferentialVariableByName$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `listReferentialVariable()` */
  static readonly ListReferentialVariablePath = '/v1/api/ui/referential/variables';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialVariable()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialVariable$Response(params: ListReferentialVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialVariable>> {
    return listReferentialVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialVariable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialVariable(params: ListReferentialVariable$Params, context?: HttpContext): Observable<ApiResponseListReferentialVariable> {
    return this.listReferentialVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialVariable>): ApiResponseListReferentialVariable => r.body)
    );
  }

  /** Path part for operation `listReferentialConversationsTags()` */
  static readonly ListReferentialConversationsTagsPath = '/v1/api/ui/referential/conversation-tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialConversationsTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialConversationsTags$Response(params: ListReferentialConversationsTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialTagConversation>> {
    return listReferentialConversationsTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialConversationsTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialConversationsTags(params: ListReferentialConversationsTags$Params, context?: HttpContext): Observable<ApiResponseListReferentialTagConversation> {
    return this.listReferentialConversationsTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialTagConversation>): ApiResponseListReferentialTagConversation => r.body)
    );
  }

}
